export enum FormFieldType {
  TEXT,
  LINK,
  TEXT_MAP
}